import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap CSS is included
import '../styles/Committee.css';
import SherriRichardson from '../images/SherriRichardson.jpg';
import AngelaArmston from '../images/AngelaArmston.jpg';
import JoanDavis from '../images/JoanDavis.jpg';
import MaryAnn from '../images/MaryAnn.jpg';
import TonyUnderhill from '../images/TonyUnd.jpg';
import MonikaUnderhill from '../images/MonikaUnderhill.jpg';
import KaiQuander from '../images/KaiQuan.jpg';
import IdalisUn from '../images/IdalisUn.jpg';
import NicoleUnd from '../images/NicoleUnd.jpg';

const Committee = () => {
    const committees = [
        {
            title: 'Family Reunion Committee',
            leader: {
                name: 'Sherri Richardson (Director)',
                imageUrl: SherriRichardson,
            },
            members: [
                {
                    name: 'Angela Armston',
                    imageUrl: AngelaArmston,
                },
                {
                    name: 'Mary Ann Williams',
                    imageUrl: MaryAnn,
                },
                {
                    name: 'Nicole Underhill-McLaurin',
                    imageUrl: NicoleUnd,
                },
                {
                    name: 'Monika Underhill',
                    imageUrl: MonikaUnderhill,
                },
            ],
        },
        {
            title: 'Technology Committee',
            leader: {
                name: 'Kai Quander',
                imageUrl: KaiQuander,
            },
            members: [
                'Carrington Armston',
                'Monika Underhill',
            ],
        },
        {
            title: 'Activities Committee',
            leader: {
                name: 'James "Tony" Underhill',
                imageUrl: TonyUnderhill,
            },
            assistantLeader: {
                name: 'Idalis Underhill (Assistant Director - Kids Activities)',
                imageUrl: IdalisUn,
            },
            members: [
                'Pharaoh Underhill',
                'Alex Underhill',
            ],
        },
        {
            title: 'T-shirt Committee',
            leader: {
                name: 'Monika Underhill',
                imageUrl: MonikaUnderhill,
            },
            members: [
                'Sulayma Underhill',
                'Idalis Underhill',
            ],
        },
        {
            title: 'History/Memorial Committee',
            leader: {
                name: 'Joan Davis',
                imageUrl: JoanDavis,
            },
            members: [
                'Linda Graves',
                'Gloria Facen',
                'Josephine Taylor',
            ],
        },
        {
            title: 'Resurrection Day Farewell Dinner',
            leader: {
                name: 'Mary Ann Williams',
                imageUrl: MaryAnn,
            },
            members: [
                'Joan Davis',
                'Nicole Underhill-McLaurin',
                'Sherri Richardson',
                'Angela Armston',
                'Monika Underhill',
                'Lamont Williams',
                'Billy McLaurin',
                'Drexel Ramseur',
                'Ed "Ritchie" Richardson',
                'Terrence Pittman',
            ],
        },
    ];

    return (
        <div className="container mt-5">
            {committees.map((committee, index) => (
                <div key={index} className="committee mb-5">
                    <h3 className="committee-title text-center mb-4">{committee.title}</h3>
                    <div className="leader-section text-center mb-4">
                        {/* Leader card */}
                        <div className="leader-card d-inline-block mx-3">
                            <img
                                src={committee.leader.imageUrl}
                                alt={committee.leader.name}
                                className="leader-image img-thumbnail mb-3"
                            />
                            <h4 className="leader-name">{committee.leader.name}</h4>
                        </div>
                        {/* Assistant Leader card */}
                        {committee.assistantLeader && (
                            <div className="leader-card d-inline-block mx-3">
                                <img
                                    src={committee.assistantLeader.imageUrl}
                                    alt={committee.assistantLeader.name}
                                    className="leader-image img-thumbnail mb-3"
                                />
                                <h4 className="leader-name">{committee.assistantLeader.name}</h4>
                            </div>
                        )}
                    </div>
                    {/* Members section */}
                    {committee.title === 'Family Reunion Committee' && (
                        <div className="leader-section text-center mb-4">
                            {committee.members.map((member, idx) => (
                                <div key={idx} className="leader-card d-inline-block mx-3">
                                    <img
                                        src={member.imageUrl}
                                        alt={member.name}
                                        className="leader-image img-thumbnail mb-3"
                                    />
                                    <h4 className="leader-name">{member.name}</h4>
                                </div>
                            ))}
                        </div>
                    )}
                    {committee.title !== 'Family Reunion Committee' && (
                        <ul className="list-unstyled text-center">
                            {committee.members.map((member, idx) => (
                                <li key={idx} className="member-name">{member}</li>
                            ))}
                        </ul>
                    )}
                </div>
            ))}
        </div>
    );
};

export default Committee;